import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { PlanSummary } from '../models/plan-summary';

@Component({
    selector: 'app-plan-list',
    templateUrl: './plan-list.component.html',
    styleUrls: ['./plan-list.component.scss']
})
export class PlanListComponent implements OnInit, OnChanges {
    @Input() plans: PlanSummary[];
    objKeys = Object.keys;
    carrierCount = {};

    constructor() {}

    ngOnInit() {}

    ngOnChanges() {
        this.carrierCount = {};
        if (this.plans) {
            this.plans.forEach(p => {
                const carrier = p.carrier['name'];
                if (!(carrier in this.carrierCount)) {
                    this.carrierCount[carrier] = 0;
                }
                this.carrierCount[carrier]++;
            });
        }
    }
}
